import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom';
import { all_routes } from '../../../router/all_routes'

interface BannerProps {
    apiValues: any;
}



const StudyEssentials: React.FC<BannerProps> = ({ apiValues }) => {
    const route = all_routes;


    const benefits = [
        {
            iconClass: "isax isax-book-1 fs-24",
            bgClass: "bg-primary-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Trusted by 113K students",
            desc: "Last year alone, Palanivel Overseas fulfilled dreams of over 113K students to study abroad. Your success is our mission!"
        },
        {
            iconClass: "isax isax-bookmark5 fs-24",
            bgClass: "bg-secondary-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Lifetime Access",
            desc: "When you enroll in our courses, you’re not just signing up for a temporary learning experience—you’re making a long-term investment."
        },
        {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        },
        {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        }, {
            iconClass: "isax isax-chart-26 fs-24",
            bgClass: "bg-skyblue-transparent",
            img: "./assets/img/shapes/palanibgcard.png",
            title: "Expert Instruction",
            desc: "Our instructors are seasoned professionals with years of experience in their respective fields & expert advice."
        },
        // Add more benefit objects as needed...
    ];
    return (
        <>
            {/* benefits */}
            <section className="benefit-section bg-[#E7E7E7] text-justify">
                <div className="container">
                    <div className="section-header text-start">
                        <span className="fw-medium text-secondary mb-2 d-inline-block">
                            {apiValues?.title || "Service to students"}

                        </span>
                        <h2 className="text-[#1D1753]">
                            {apiValues?.description || "Student Essentials Services"}
                        </h2>
                        <p className="text-[#1D1753]">
                            {apiValues?.miniDescription || "Support services designed to make your overseas journey stress-free and successful."}
                        </p>
                    </div>
                    <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {apiValues?.ourServicesCards?.map((item: any, index: number) => (
                            <div key={index} className="card newGradient card-hover-effect w-full h-full">
                                <div className="card-body p-4 flex flex-col h-full">
                                    <div className="flex ">
                                        <div className='flex p-2 rounded-pill bg-[#FFEDF0]'>
                                            <ImageWithBasePath
                                                source={item?.iconUrl}
                                                className="rounded-full"
                                                style={{ width: 40, height: 40 }}
                                                alt="Img"
                                            />
                                        </div>

                                    </div>
                                    <h5 className="mt-3 mb-1 !text-[#1D1753]">{item.title}</h5>
                                    <p className="!text-[#1D1753] mb-4 flex-grow">{item.description}</p>
                                    <Link to={`${route.learnMore}/${item._id}`} className="mt-auto">
                                        <button className="learn-more-btn">
                                            <span className="btn-text">{item.buttonText}</span>
                                            <span className="btn-arrow">→</span>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>


                </div>
            </section >
            {/* benefits */}
        </>

    )
}

export default StudyEssentials
